import { render, staticRenderFns } from "./ChecklistConfig.vue?vue&type=template&id=5848541a"
import script from "./ChecklistConfig.vue?vue&type=script&lang=js"
export * from "./ChecklistConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports